<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Instalações</h4>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>CNPJ</th> 
                <th class="text-right">Vendas Hoje</th> 
                <th class="text-right">Última Sinc.</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao of instalacoes">
                <td>{{ instalacao.apelido }} ({{ instalacao.idi }})</td>
                <td>{{ instalacao.cnpj }}</td>
                <td class="text-center">{{ instalacao.hora }}</td>
                <td class="text-right">{{ instalacao.ultima_conexao_ws | moment('DD/MM/YYYY HH:mm')}}</td>
                <td class="text-right">
                  <div v-if="instalacao.status_nota" class="status" v-bind:class="[instalacao.status_nota]"></div>
                  <div class="status" v-bind:class="[instalacao.status]"></div>
                </td>
              </tr>
              <tr v-if="!instalacoes || !instalacoes.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import InstalacaoService from '@/services/InstalacaoService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        instalacoes: [],
        total: 0,

        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadInstalacoes()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadInstalacoes()
      },
      loadInstalacoes() {
        InstalacaoService.load(`?page=${this.current_page}`).then(res => {
          console.log(res.data.data)
          this.pageCount = res.data.last_page
          this.instalacoes = res.data.data
          this.from = res.data.from
          this.to = res.data.to
          this.total = res.data.total; 
        }).catch(err => {
          console.error(err)
        })
      },

      getUnidade(unidade) {
        let unidades = [  
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]

        console.log(unidades[unidade])
        return unidades[unidade];
      },
    },
    mounted() {
      // this.loadInstalacoes
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>